import Vue from 'vue'
import firebase from "firebase"
import App from './App.vue'
import router from './routes/router'
import store from './store'
import './registerServiceWorker'

import './styles/general.styl'
import './styles/quasar.styl'
import 'quasar-framework/dist/quasar.ie.polyfills'
import lang from 'quasar-framework/i18n/es'
import 'quasar-extras/animate'
import 'quasar-extras/roboto-font'
import 'quasar-extras/material-icons'
import 'quasar-extras/fontawesome'
import 'quasar-extras/ionicons'
import 'quasar-extras/mdi'
import Quasar from 'quasar'

Vue.use(Quasar, {
   config: {}, i18n: lang
})

Vue.config.productionTip = false

let app = '';

firebase.initializeApp({
   apiKey: "AIzaSyB34t4tHQfsXYLnwFVrGINK67N6DfqzUBQ",
   authDomain: "artesaniatejesol.firebaseapp.com",
   databaseURL: "https://artesaniatejesol.firebaseio.com",
   projectId: "artesaniatejesol",
   storageBucket: "artesaniatejesol.appspot.com",
   messagingSenderId: "124677378569"
})

firebase.auth().onAuthStateChanged(()=>{
   if (!app) {
      app = new Vue({
         router,
         store,
         render: h => h(App)
      }).$mount('#app')
   }
})
